import React, { useContext } from 'react';
import { Box, Typography, Button, CircularProgress, IconButton } from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';
import { useDispatch } from 'react-redux';
import { DELETE_SKILL } from '../../Reducers/Actions';
import { useDeleteSkillMutation } from '../../services/SkillsManagement';
import MuiDialog from '../../SystemDesign/MuiDialog';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';

const DeleteSkill = ({ open, onClose, skill, onDeleted }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  
  // RTK Query deletion hook
  const [deleteSkillMutation, { isLoading }] = useDeleteSkillMutation();
  
  // Access the SnackBar context
  const { setOpenSnackBar, setInfoAlert } = useContext(SnackBarContext);
  
  // Handle skill deletion
  const handleDelete = async () => {
    if (!skill) return;
    
    try {
      // Get a valid skill ID - normalize ID format
      const skillId = skill.skill_id || skill.id;
      
      // Call API to delete the skill
      const response = await deleteSkillMutation({
        skillId: skillId
      }).unwrap();
      
      console.log('Skill deletion API response:', response);
      
      // Update Redux store
      dispatch({ type: DELETE_SKILL, payload: skillId });
      
      // Show success message
      setInfoAlert({
        severity: 'success',
        message: `Skill "${skill.skill_name || skill.name || 'Unknown'}" successfully deleted`
      });
      setOpenSnackBar(true);
      
      // Call the onDeleted callback if provided
      // This is critical for triggering a refetch in the parent component
      if (onDeleted) {
        onDeleted(skillId);
        console.log('Called onDeleted with skillId:', skillId);
      }
      
      // Close the dialog
      onClose();
    } catch (error) {
      console.error('Failed to delete skill:', error);
      
      // Show error message
      setInfoAlert({
        severity: 'error',
        message: error?.data?.message || 'Failed to delete skill'
      });
      setOpenSnackBar(true);
    }
  };

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      icon={<DeleteOutlineIcon />}
      title="Delete Skill?"
      subtitle={`Are you sure you want to delete "${skill?.skill_name || skill?.name || 'Unknown'}"? This action cannot be undone.`}
      maxWidth="xs"
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleDelete}
      isLoading={isLoading}
      actionType="button"
    />
  );
};

export default DeleteSkill;